// Horizontal scrolling strip of sample prompts — pulled from real beta user queries.
const PROMPTS: { icon: string; text: string }[] = [
  { icon: "🩺", text: "What was Fluffy's last BCS?" },
  { icon: "📋", text: "Make the plan section bullet form." },
  { icon: "🔬", text: "Is trazodone safe with SSRIs?" },
  { icon: "📎", text: "[Lab.pdf] Flag anything off." },
  { icon: "🐾", text: "Fluid rate for a 12kg dog at 2x maintenance?" },
  { icon: "💉", text: "Draft a client email about Fluffy's dental." },
  { icon: "🧪", text: "Summarize Luna's bloodwork from the last year." },
  { icon: "💡", text: "What's a reasonable DDx for PU/PD in an older cat?" },
  { icon: "📝", text: "Any feedback on how I handled that appointment?" },
  { icon: "🐕", text: "Max's last rabies vaccine — when is he due?" },
  { icon: "⚖️", text: "Alprazolam dose for a 4.2kg cat, 3 days." },
];

export function PromptsStrip() {
  // Duplicate the list so the CSS translate(-50%) loop seams cleanly.
  const loopList = [...PROMPTS, ...PROMPTS];

  return (
    <section className="py-[clamp(40px,5vw,64px)]">
      <div className="mx-auto max-w-[1240px] px-[clamp(24px,5vw,80px)]">
        <div className="mb-7 text-center">
          <div className="mb-2 text-xs font-semibold uppercase tracking-[0.08em] text-indigo-700">
            Just ask
          </div>
          <h3 className="font-companion tracking-[-0.01em] m-0 text-2xl font-bold tracking-[-0.02em] text-primary">
            Real questions you can ask Companion.
          </h3>
        </div>
      </div>

      <div className="prompts-marquee relative overflow-hidden py-8 [-webkit-mask-image:linear-gradient(90deg,transparent,black_8%,black_92%,transparent)] [mask-image:linear-gradient(90deg,transparent,black_8%,black_92%,transparent)]">
        <div className="prompts-marquee-track flex w-max gap-3.5 pl-3.5 animate-[promptsScroll_160s_linear_infinite]">
          {loopList.map((p, i) => (
            <div
              key={i}
              className="prompt-chip flex min-w-[280px] shrink-0 cursor-default items-center gap-3 rounded-[14px] border border-grindigo-100 bg-white px-5 py-4 shadow-[0_2px_10px_-6px_rgba(99,102,241,0.15)] transition-[transform,box-shadow,border-color] duration-150 ease-[ease]"
            >
              <span className="text-[22px]">{p.icon}</span>
              <div className="text-sm font-medium leading-[1.4] text-primary [text-wrap:pretty]">
                {p.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
